import { Button, Form } from 'antd';
import TextInput from '../inputs/TextInput';
import translations from '../../hooks/translation/translations.json';

function GeneratedPaymentsReportForm({ onFinish }) {
  return (
    <Form onFinish={onFinish} layout="vertical" className="grid grid-cols-3 gap-x-4 ">
      <TextInput label={translations.ka.email} name="email" />
      <Form.Item label=" ">
        <Button type="primary" htmlType="submit">{translations.ka.send}</Button>
      </Form.Item>
    </Form>
  );
}

export default GeneratedPaymentsReportForm;
